import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { summaryPackages } from "@redotech/redo-fulfillment-group-common/shipment-summary";
import { Flex } from "@redotech/redo-web/flex";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { ShipmentTrackerStatusBadge } from "../../common/shipment-tracker-status-badge";
import { getEffectiveShipmentSummary } from "../../utils/effective-shipment-summary";

const catalogEntry = fgColumnEntries["delivery-status"];

export const DeliveryStatusColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    const trackingStatus = summaryPackages(getEffectiveShipmentSummary(row))[0]
      ?.trackingStatus;
    return (
      trackingStatus && (
        <Flex pl="lg">
          <ShipmentTrackerStatusBadge shipmentTrackerStatus={trackingStatus} />
        </Flex>
      )
    );
  },
  width: catalogEntry.defaultWidth,
  sort: catalogEntry.sortDirection,
};
